import _createClass from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getChannels } from './packing_util';
import { getCoordsDataType } from './shader_compiler';
export var ReversePackedProgram = /*#__PURE__*/_createClass(function ReversePackedProgram(xShape, axis) {
  _classCallCheck(this, ReversePackedProgram);
  this.variableNames = ['x'];
  this.packedInputs = true;
  this.packedOutput = true;
  var rank = xShape.length;
  if (rank > 4) {
    throw new Error("WebGL backend: Reverse of rank-".concat(rank, " tensor is not yet supported"));
  }
  this.outputShape = xShape;
  var channels = getChannels('rc', rank);
  var nextColumn = "".concat(channels[rank - 1], " + 1 < ").concat(this.outputShape[rank - 1]);
  var nextRow = "".concat(channels[rank - 2], " + 1 < ").concat(this.outputShape[rank - 2]);
  var type = getCoordsDataType(rank);
  if (rank === 1) {
    this.userCode = "\n        void main(){\n          int rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = getChannel(getX(".concat(xShape[0], " - rc - 1),\n            ").concat(xShape[0], " - rc - 1);\n          if(").concat(nextColumn, "){\n              result.g = getChannel(getX(").concat(xShape[0], " - (rc  + 1) - 1),\n                ").concat(xShape[0], " - (rc  + 1) - 1);\n          }\n          setOutput(result);\n        }\n      ");
  } else {
    this.userCode = "\n        void main() {\n          ".concat(type, " rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = ").concat(getR(channels.slice()), ";\n          if(").concat(nextColumn, "){\n            result.g = ").concat(getG(channels.slice()), ";\n          }\n          if(").concat(nextRow, ") {\n            result.b = ").concat(getB(channels.slice()), ";\n            if(").concat(nextColumn, ") {\n              result.a = ").concat(getA(channels.slice()), ";\n            }\n          }\n          setOutput(result);\n        }\n    ");
  }
  function getR(channels) {
    return getChannel(channels);
  }
  function getG(channels) {
    channels[rank - 1] = '(' + channels[rank - 1] + " + 1)";
    return getChannel(channels);
  }
  function getB(channels) {
    channels[rank - 2] = '(' + channels[rank - 2] + " + 1)";
    return getChannel(channels);
  }
  function getA(channels) {
    channels[rank - 1] = '(' + channels[rank - 1] + " + 1)";
    channels[rank - 2] = '(' + channels[rank - 2] + " + 1)";
    return getChannel(channels);
  }
  function getChannel(channels) {
    var inCoordsArray = xShape.map(function (_, i) {
      return getInCoord(i, channels);
    });
    var inCoords = inCoordsArray.join(',');
    var innerDims = inCoordsArray.slice(-2).join(',');
    return "getChannel(getX(".concat(inCoords, "), vec2(").concat(innerDims, "))");
  }
  function getInCoord(i, channels1) {
    if (axis.indexOf(i) !== -1 && xShape[i] !== 1) {
      return "".concat(xShape[i], " - ").concat(channels1[i], " - 1");
    } else {
      return "".concat(channels1[i]);
    }
  }
});